import { useSelector } from 'react-redux';
import { Button, DeprecatedIcon } from '@vinted/web-ui';
import { getItemStatus } from 'data/utils/item';
import { ClickableElement } from 'constants/tracking/clickable-elements';
import { clickEvent, favouriteItemEvent } from 'libs/common/event-tracker/events';
import useTracking from 'hooks/useTracking';
import ProfileItemPushUpButton from 'components/ProfileItemPushUpButton';
import { ProductItem } from 'components/ProductItem';
import { ContentSource } from 'constants/tracking/content-sources';
import { ITEM_URL } from 'constants/routes';
import { transformItemDtoToProductItem } from 'data/transformers/product-item';
import { getVasGalleryAbTest } from 'state/vas-gallery/selectors';
import { jsx as _jsx } from "react/jsx-runtime";

const FeaturedItem = _ref => {
  let {
    innerRef,
    item,
    onClick,
    viewingSelf = false,
    allowBump = false,
    isDescriptionHidden
  } = _ref;
  const {
    track
  } = useTracking();
  const vasGalleryAbTest = useSelector(getVasGalleryAbTest);

  const onActionClick = (target, itemId) => () => {
    const trackingEvent = clickEvent({
      target,
      targetDetails: itemId.toString()
    });
    track(trackingEvent);
  };

  function handleFavouriteToggle(_ref2) {
    let {
      itemId,
      isFollowEvent
    } = _ref2;
    track(clickEvent({
      target: ClickableElement.Favourite
    }));
    track(favouriteItemEvent({
      itemId,
      isFollowEvent,
      contentSource: ContentSource.FeaturedCollection
    }));
  }

  const renderPerformanceChartButton = id => /*#__PURE__*/_jsx(Button, {
    text: /*#__PURE__*/_jsx(DeprecatedIcon, {
      name: "performance-chart",
      size: DeprecatedIcon.Size.Small,
      color: "parent"
    }),
    theme: "primary",
    size: Button.Size.Small,
    url: ITEM_URL(id),
    onClick: onActionClick(ClickableElement.ShowItemPerformance, id),
    testId: "featured-item--stats"
  });

  function renderItemFooter() {
    if (!viewingSelf || isDescriptionHidden) return null;
    const {
      id,
      promoted,
      vas_gallery_promoted
    } = item;
    const status = getItemStatus(item, viewingSelf);

    switch (status) {
      case 'promoted':
        {
          if (!promoted && allowBump) return /*#__PURE__*/_jsx(ProfileItemPushUpButton, {
            item: item
          });
          return renderPerformanceChartButton(id);
        }

      case 'bumped':
        {
          if (vasGalleryAbTest.visible && !vas_gallery_promoted) return /*#__PURE__*/_jsx(ProfileItemPushUpButton, {
            item: item
          });
          return renderPerformanceChartButton(id);
        }

      default:
        {
          if (!allowBump) return null;
          return /*#__PURE__*/_jsx(ProfileItemPushUpButton, {
            item: item
          });
        }
    }
  }

  return /*#__PURE__*/_jsx("div", {
    className: "featured-collection__item",
    ref: innerRef,
    "data-testid": "featured_collection_item",
    children: /*#__PURE__*/_jsx(ProductItem, {
      item: transformItemDtoToProductItem(item),
      showOwner: false,
      showStatus: true,
      renderFooter: renderItemFooter(),
      onClick: onClick,
      viewingSelf: viewingSelf,
      testId: "featured-item",
      hideBusinessBadge: true,
      isDescriptionHidden: isDescriptionHidden,
      onFavouriteToggle: handleFavouriteToggle
    })
  });
};

export default FeaturedItem;